import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import helper from './helper';
import { Filters, RequestPayload } from './types';

const API_URL = process.env.REACT_APP_SOCKET_API_ENDPOINT;

export type GetBlocksPayload = {
  offset: number;
  limit: number;
  username?: string;
  block?: string;
  period_begin?: string;
  period_end?: string;
};

export type Delivery = {
  id: string;
  key: string;
  createdTimestamp: number, 
  receivedTimestamp: number, 
  sentTimestamp: number, 
  banTimestamp: number, 
  transferError: {String: string, Valid: boolean},  
  parseError: {String: string, Valid: boolean}, 
  userDevice: string, 
  request: {String: string, Valid: boolean},  
  response: {String: string, Valid: boolean}, 
  status: string
};

export type Session = {
  id: string, 
  created: number, 
  lastVisit: number, 
  username: string, 
  userInfo: string, 
  closed: boolean, 
  deviceId: string, 
  device: string, 
  appVersion: string
};

export type Activity = {
  id: number,
  username: string,
  activity: string,
  timestamp: number,
  deliveryId: number,
  photos: string[],
  thumbnails: string[],
  entityId: string,
  status: string,
  location: number[],
}

let abortController;

export type UpdateStatusPayload = {
  masterOutletId?: string,
  outletName: string,
  comment?: string,
}

const socketService = (
  instance: AxiosInstance,
  config: AxiosRequestConfig
) => ({
  getDeliveries: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Delivery>>>(
      `${API_URL}deliveries`,
      payload,
      { ...config, baseURL: '/' }
    ),
  getDelivery: (id: string) =>
    instance.get<ApiResponse<Delivery>>(
      `${API_URL}delivery?id=${id}`,
      { ...config, baseURL: '/' }
    ),
  getSessions: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Session>>>(
      `${API_URL}sessions`,
      payload,
      { ...config, baseURL: '/' }
    ),
  getActivitiesLocation: (bbox: number[], filter: Filters) =>
    {
      if (abortController && !abortController.signal.aborted) {
        abortController.abort();
        console.log('abort', abortController);
      }
      abortController = new AbortController();
      return instance.post<ApiResponse<Activity[]>>(
        `${API_URL}activities/location`,
        {
          bbox,
          filter,
        },
        {
          ...config,
          baseURL: '/',
          signal: abortController.signal,
          
        }
      );
    },
    
  getActivities: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Activity>>>(
      `${API_URL}activities/gallery`,
      payload,
      { ...config, baseURL: '/' }
    ),
  updateStatusACL: (id: string, entity: 'acl-new-outlet' | 'acl-update-outlet', status: 'completed' | 'rejected', payload: UpdateStatusPayload) =>
    instance.put<ApiResponse<any>>(
      `${API_URL}update-entity-status?id=${id}&entity=${entity}&status=${status}`,
      { ...payload },
      { ...config, baseURL: '/' }
    ),
});

export default socketService;
